
import axios from '@/axios.js'
import url from '@/url.js'

export default {
  getTransaksi({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "desc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/pembayaran`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getTransaksiNonLogin({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "desc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/pembayaran/non-login`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getMetodePembayaran({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "desc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/metode-pembayaran`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        commit('SET_TOTAL_METODE', res.data.recordsTotal)
        commit('SET_METODE_LIST', res.data.data)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getTutorialPembayaran({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "desc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/tutor-pembayaran`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        commit('SET_TOTAL_TP', res.data.recordsTotal)
        commit('SET_TUTOR_LIST', res.data.data)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getJenisTransaksi({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'get',
        url: `${url.base}/jenis-transaksi`,
        params: Object.assign(payload),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        commit('SET_TOTAL_JENIS', res.data.recordsTotal)
        commit('SET_JENIS_LIST', res.data.data)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudTutorialPembayaran({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/tutor-pembayaran`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudTransaksi({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/pembayaran`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudMetodePembayaran({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/metode-pembayaran`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudJenisTransaksi({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/jenis-transaksi`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
}
